module.exports = __webpack_public_path__ + "img/bid_thumb3.f73d18ab.png";